function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3695",
  "data-name": "Grupo 3695",
  transform: "translate(0 2.875)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7967",
  d: "M317.743 418.979q-.731 0-1.472-.046c-11.464-.745-20.441-10.64-20.441-22.53v-12.728a6.344 6.344 0 0 1 6.337-6.337h3.56a2.051 2.051 0 0 1 0 4.1h-3.56a2.239 2.239 0 0 0-2.239 2.234V396.4c0 9.736 7.3 17.833 16.608 18.437a17.8 17.8 0 0 0 18.986-17.758v-13.404a2.239 2.239 0 0 0-2.237-2.234H329a2.051 2.051 0 0 1 0-4.1h4.28a6.344 6.344 0 0 1 6.337 6.337v13.408a22 22 0 0 1-6.922 15.979 21.7 21.7 0 0 1-14.952 5.914z",
  className: "cls-1",
  "data-name": "Caminho 7967",
  transform: "translate(-295.83 -377.338)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3696",
  "data-name": "Grupo 3696",
  transform: "translate(19.845 38.172)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7968",
  d: "M327.7 415.938h-14.365a8.806 8.806 0 0 1-8.793-8.795v-10.015a2.05 2.05 0 1 1 4.1 0v10.016a4.7 4.7 0 0 0 4.692 4.692H327.7a4.7 4.7 0 0 0 4.692-4.692v-12.26a2.05 2.05 0 1 1 4.1 0v12.259a8.806 8.806 0 0 1-8.792 8.795z",
  className: "cls-1",
  "data-name": "Caminho 7968",
  transform: "translate(-304.542 -392.834)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3697",
  "data-name": "Grupo 3697",
  transform: "translate(44.145 30.929)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7969",
  d: "M320.82 400.882a5.614 5.614 0 1 1 5.613-5.615 5.618 5.618 0 0 1-5.613 5.615zm0-7.125a1.511 1.511 0 1 0 1.512 1.51 1.512 1.512 0 0 0-1.512-1.511z",
  className: "cls-1",
  "data-name": "Caminho 7969",
  transform: "translate(-315.21 -389.654)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3698",
  "data-name": "Grupo 3698",
  transform: "translate(7.847)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7970",
  d: "M306.528 385.925h-2.879a4.377 4.377 0 0 1-4.373-4.371v-1.107a4.378 4.378 0 0 1 4.373-4.371h2.879a4.377 4.377 0 0 1 4.371 4.371v1.107a4.375 4.375 0 0 1-4.371 4.371zm-2.879-5.747a.272.272 0 0 0-.273.269v1.107a.272.272 0 0 0 .273.271h2.879a.272.272 0 0 0 .273-.271v-1.107a.272.272 0 0 0-.273-.269z",
  className: "cls-1",
  "data-name": "Caminho 7970",
  transform: "translate(-299.275 -376.076)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3699",
  "data-name": "Grupo 3699",
  transform: "translate(23.601)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_7971",
  d: "M313.444 385.925h-2.882a4.377 4.377 0 0 1-4.371-4.371v-1.107a4.378 4.378 0 0 1 4.371-4.371h2.882a4.378 4.378 0 0 1 4.371 4.371v1.107a4.377 4.377 0 0 1-4.371 4.371zm-2.882-5.747a.27.27 0 0 0-.271.269v1.107a.27.27 0 0 0 .271.271h2.882a.272.272 0 0 0 .271-.271v-1.107a.271.271 0 0 0-.271-.269z",
  className: "cls-1",
  "data-name": "Caminho 7971",
  transform: "translate(-306.191 -376.076)"
}));

var SvgSteto = function SvgSteto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_3700",
    width: 55.368,
    height: 61.277,
    "data-name": "Grupo 3700",
    viewBox: "0 0 55.368 61.277",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSteto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steto.c8ac7101.svg";
export { ForwardRef as ReactComponent };